module.exports = __webpack_public_path__ + "img/valveOn.505bfcfb.gif";